export default __webpack_public_path__ + "assets/images/g-icon7-88750986.svg";